<template>
    <nav class="pagination">
        <div class="inline">
            <span class="page-stats">{{pagination.from}} - {{pagination.to}} von {{pagination.total}}</span>
        </div>

        <div class="btn-wrapper inline">
            <a v-if="pagination.prevPageUrl || (client && pagination.prevPage !== '')"
               class="button is-small pagination-previous" @click="$emit('prev');">
                &#8249;
            </a>
            <a class="button is-small pagination-previous disabled" v-else :disabled="true">
                &#8249;
            </a>

            <a v-if="pagination.nextPageUrl || (client && pagination.nextPage !== '')"
               class="button is-small pagination-next is-active" @click="$emit('next');">
                &#8250;
            </a>
            <a class="button is-small pagination-next is-active disabled" v-else :disabled="true">
                &#8250;
            </a>
        </div>

    </nav>
</template>

<script>
    export default {
        props: {
            'pagination': Object,
            'filtered': Array,
            'client': {type: Boolean, default: false}
        }
    }
</script>

<style lang="scss" scoped>
    .pagination {
        //  justify-content: flex-end !important;
        width: 100%;

        .page-stats {
            align-items: center;
            margin-right: 5px;
        }

        i {
            color: #3273dc !important;
        }

        .pagination-previous.disabled, .pagination-next.disabled{
            cursor: default;
            user-select: none;
        }
        .pagination-previous, .pagination-next{
            &:not(.disabled):hover{
                background: #00b6ed;
                border-color: #00b6ed;
                color: #fff;
            }
        }

    }

    .is-active {
        background-color: #939BA2;
        color: #fff;
    }

    a {
        border: 2px solid #939BA2;
        border-radius: 50%;
        margin: auto 5px;
        color: #939BA2;
        font-weight: bold;
    }

    a {
        display: inline-block;
        padding: .5em 1em;
        color: #939BA2;
        cursor: pointer;
    }

    .btn-wrapper {
        float: right;
    }

    .inline {
        display: inline-block;
    }
</style>
